﻿const name = 'comprovantePagamento'
const controller = () => import('./controller.js')
const templateUrl = new URL('./template.html', import.meta.url).href;

export default {
    name,
    templateUrl,
    controller
};
